import axios, { AxiosPromise } from 'axios';

export default class FarmMasterDataSyncHttpService {
    public static getSyncStatus() : AxiosPromise<boolean> {
        return axios.get(`${API_URL}/v1/PackmanFarmSync/GetSyncStatus`);
    }

    public static setSyncStatus() : AxiosPromise<boolean> {
        return axios.post(`${API_URL}/v1/PackmanFarmSync/SetSyncStatus`);
    }

    public static triggerFullSync() : AxiosPromise<boolean> {
        return axios.get(`${API_URL}/v1/PackmanFarmSync/FullSync`);
    }

    public static triggerLastUpdatedSync() : AxiosPromise<boolean> {
        return axios.get(`${API_URL}/v1/PackmanFarmSync/LastUpdateSync`);
    }
}
